import {
  ListBulletsIcon,
  TextAlignLeftIcon,
  UserListIcon,
  MagnifyingGlassIcon,
  LockKeyIcon,
  FileDocIcon,
  SparkleIcon,
} from "@phosphor-icons/react";

const features = [
  {
    icon: ListBulletsIcon,
    title: "Structure submissions",
    body: "Designed around the core sections and submission logic used by Chambers & Partners and The Legal 500.",
  },
  {
    icon: TextAlignLeftIcon,
    title: "Strengthen matter descriptions",
    body: "Turn flat descriptions into structured, evidence-backed narratives that are easier to understand and evaluate.",
  },
  {
    icon: UserListIcon,
    title: "Build aligned lawyer bios",
    body: "Keep partner profiles consistent across submissions, websites and individual nominations.",
  },
  {
    icon: MagnifyingGlassIcon,
    title: "Identify missing or weak information",
    body: "Spot gaps, missing context and unsupported claims before partners review the document.",
  },
  {
    icon: LockKeyIcon,
    title: "Tag confidential information",
    body: "Mark sensitive content so it’s handled with the right confidentiality treatment throughout.",
  },
  {
    icon: FileDocIcon,
    title: "Export an editable Word document",
    body: "Hand off a clean .docx your team can finalise, review and file with full ownership.",
  },
];

export default function Product() {
  return (
    <section id="product" data-testid="product-section" className="py-24 md:py-32 bg-[#f7f4ec]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
            What Ranq does
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900">
            From scattered information to a structured submission.
          </h2>

          <div
            data-testid="product-differentiator"
            className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-[#f3efe6] border border-stone-200 px-4 py-2"
          >
            <SparkleIcon size={16} weight="fill" className="text-[#ff5e3a]" />
            <span className="text-sm font-medium text-stone-800">
              Built with legal directory methodology, not generic AI.
            </span>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, idx) => {
            const Icon = f.icon;
            return (
              <div
                key={idx}
                data-testid={`product-feature-${idx}`}
                className="relative rounded-2xl border border-stone-200 bg-[#f3efe6]/60 p-7 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:border-stone-300"
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-stone-900 text-[#f7f4ec] mb-5">
                  <Icon size={22} weight="duotone" />
                </div>
                <h3 className="font-heading text-lg md:text-xl font-medium text-stone-900">
                  {f.title}
                </h3>
                <p className="mt-2 text-stone-600 leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
